import {
  InMemoryHeader,
  InMemoryString,
} from "pbas-vue-components";
import { translate2 } from "../trans2";
const headers = [
  new InMemoryHeader({
    type: new InMemoryString("Identifier"),
    sortable: false,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "components.plan_benefit_rules.import_benefit_rules_configuration_dialog.benefit_rules",
    type: new InMemoryString("File", {
      getString: item => {
        if (item.File === null || item.File === undefined) {
          return "";
        }
        return item.File
      }
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "components.plan_benefit_rules.import_benefit_rules_configuration_dialog.plan_group_limit_rules",
    type: new InMemoryString("FileGroupLimit", {
      getString: item => {
        console.log(item.FileGroupLimit);
        if (item.FileGroupLimit === null || item.FileGroupLimit === undefined) {
          return "";
        }
        return item.FileGroupLimit;
      }
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "components.plan_benefit_rules.import_benefit_rules_configuration_dialog.plan_health_limit_rules",
    type: new InMemoryString("HealthLimitRules", {
      getString: item => {
        if (item.HealthLimitRules === null || item.HealthLimitRules === undefined) {
          return "";
        }
        return item.HealthLimitRules;
      },
      getHtml: (item, type) => {
        return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
        );
      }
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "components.plan_benefit_rules.import_benefit_rules_configuration_dialog.plan_dental_limit_rules",
    type: new InMemoryString("DentalLimitRules", {
      getString: item => {
        if (item.DentalLimitRules === null || item.DentalLimitRules === undefined) {
          return "";
        }
        return item.DentalLimitRules;
      },
      getHtml: (item, type) => {
        return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
        );
      }
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "components.plan_benefit_rules.import_benefit_rules_configuration_dialog.plan_limit_rules",
    type: new InMemoryString("LimitRules", {
      getString: item => {
        if (item.LimitRules === null || item.LimitRules === undefined) {
          return "";
        }
        return item.LimitRules;
      },
      getHtml: (item, type) => {
        return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
        );
      }
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "globals.member_groups",
    type: new InMemoryString("MemberGroups", {
      getString: item => {
        if (item.MemberGroups === null || item.MemberGroups === undefined) {
          return "";
        }
        return item.MemberGroups.map(o=>translate2(o, "Name")).join(",");
      },
      getHtml: (item, type) => {
        return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
        );
      }
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
];
function getHeaders() {
  return headers;
}
export default getHeaders;